import { render } from "./ControlloFattureFornitoriEE.vue?vue&type=template&id=3be54c60"
import script from "./ControlloFattureFornitoriEE.vue?vue&type=script&lang=js"
export * from "./ControlloFattureFornitoriEE.vue?vue&type=script&lang=js"

import "./ControlloFattureFornitoriEE.vue?vue&type=style&index=0&id=3be54c60&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__